import React, { useState, useEffect } from "react";
import Text from "../../../../../../../_components/Text";
import LoadingInput from "../../../../../../../_components/LoadingInput";

import { CreateNFeContext } from "../../../Context";

export default (props) => {
  const context = React.useContext(CreateNFeContext);
  const [sendDate, setSendDate] = React.useState(new Date());
  const [updateDate, setUpdateDate] = React.useState(new Date());
  const [currentDateTime, setCurrentDateTime] = useState(getCurrentDateTime());

  function getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  function onChangeSendDate(e) {
    setCurrentDateTime(e.target.value)
    setSendDate(e.target.value)
    const { nfe } = context
    nfe.identification.send_date = e.target.value;
    context.handlers.updateNFeData(nfe);
  }
  
  function onChangeUpdateDate(e) {
    setCurrentDateTime(e.target.value)
    setUpdateDate(e.target.value)
    const { nfe } = context
    nfe.identification.update_date = e.target.value;
    context.handlers.updateNFeData(nfe);
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDateTime(getCurrentDateTime())
    }, 60000) // atualiza a cada minuto, não sei se é util

    return () => clearInterval(intervalId)
  }, [])

  return (
    props.dateType == "sendDate" ? 
      <div className="">
        <Text color="primary">Data de emissão da NFe</Text>
        <LoadingInput onChange={onChangeSendDate} value={currentDateTime} type="datetime-local" />
      </div>
    :
      <div className="">
        <Text color="primary">Data de saída da NFe</Text>
        <LoadingInput onChange={onChangeUpdateDate} value={currentDateTime} type="datetime-local" />
      </div>
    );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Details/SendDate/index.jsx